import MixtilesDialog from 'components/MixtilesDialog/MixtilesDialog'
import { promoCodeManager } from 'services/PromoCodeManager'
import useScreenSize from 'hooks/useScreenSize'
import * as S from './CancelPromoCodeDialog.styles'
import Button, { VARIANTS } from 'mixtiles-web-common/ui/Button'
import { useTranslation } from 'react-i18next'

export default function CancelPromoCodeDialog({
  show,
  onDismiss,
  onCancel = () => {},
}) {
  const { t } = useTranslation()
  const isPopup = useScreenSize('sm')

  function cancelPromoCode() {
    promoCodeManager.removeDiscountCoupon()
    onDismiss()
    onCancel()
  }

  const Content = (
    <>
      <S.Title>{t('order.checkout.promo.cancel')}</S.Title>
      <S.Subtitle>{t('order.checkout.are_you_sure')}</S.Subtitle>
      <S.CtaButton>
        <Button onClick={cancelPromoCode} minWidth="248px">
          {t('order.checkout.promo.yes_remove')}
        </Button>
      </S.CtaButton>
      <S.DismissButton>
        <Button variant={VARIANTS.light} onClick={onDismiss} minWidth="248px">
          {t('order.checkout.no_go_back')}
        </Button>
      </S.DismissButton>
    </>
  )

  return isPopup ? (
    <MixtilesDialog
      open={show}
      onDismiss={onDismiss}
      fullScreen={false}
      closeButtonOnDialog
      className="PromoCodeDialog"
      maxWidth="sm"
    >
      {Content}
    </MixtilesDialog>
  ) : (
    <S.BottomDrawer anchor="bottom" open={show} onClose={onDismiss}>
      {Content}
    </S.BottomDrawer>
  )
}
